import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";
import { ConfirmButton } from "../common/ConfirmButton";

export default function BackupCodesCard() {
  const { data, reload } = useApi("/auth/mfa/backup-codes");
  const [codes, setCodes] = useState(null);
  const [busy, setBusy] = useState(false);
  const generate = async () => {
    setBusy(true);
    try { const r = await api.post("/auth/mfa/backup-codes"); setCodes(r.data.codes); reload(); toast.success("Nouveaux codes générés"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-surface space-y-4 p-6" data-testid="backup-codes-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div><p className="flex items-center gap-2 font-display font-semibold"><KeyRound className="h-4 w-4 text-blue-600" />Codes de secours</p>
          <p className="mt-1 text-sm text-slate-500">Utilisables une seule fois si le code par email n'arrive pas. {data && <span data-testid="backup-codes-remaining">{data.remaining} code(s) restant(s).</span>}</p></div>
        <ConfirmButton testId="backup-codes-generate" title="Générer de nouveaux codes ?" description="Les anciens codes de secours seront immédiatement invalidés."
          confirmLabel="Générer" onConfirm={generate}
          trigger={<Button variant="outline" size="sm" disabled={busy} data-testid="backup-codes-generate">{busy && <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />}Générer des codes</Button>} />
      </div>
      {codes && (
        <div className="rounded-lg border border-amber-200 bg-amber-50 p-4" data-testid="backup-codes-list">
          <p className="mb-2 text-sm font-medium text-amber-900">Notez ces codes maintenant : ils ne seront plus jamais affichés.</p>
          <div className="grid grid-cols-2 gap-1 font-mono text-sm sm:grid-cols-5">{codes.map((c) => <span key={c}>{c}</span>)}</div>
        </div>
      )}
    </div>
  );
}
